import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../assets/Css/AdsManagement.css";
import Outlet from "../Outlet";

const PlusCircle = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

const Trash2 = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" />
  </svg>
);

const Edit = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
  </svg>
);

const CheckCircle = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const XCircle = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

const AdsManagement = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [currentAd, setCurrentAd] = useState(null);

  const [form, setForm] = useState({
    name: localStorage.getItem("adName") || "",
    unitId: "",
    active: true,
  });

  const API_URL = "https://network.rentel.in/config";

  // 🔹 Fetch Ads
  const fetchAds = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${API_URL}/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });

      if (res.data?.config) {
        setAds([
          {
            id: res.data.config._id,
            name: localStorage.getItem("adName") || "", // ⭐ FIXED
            unitId: res.data.config.googleAdsUnitId,
            active: res.data.config.isAdEnable,
          },
        ]);
      } else {
        setAds([]);
      }
    } catch (err) {
      setError("Failed to fetch ads configuration.");
      setAds([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      fetchAds();
    } else {
      setError("Authentication token missing. Please login.");
      setLoading(false);
    }
  }, []);

  // 🔹 Open Modal
  const openModal = (ad = null) => {
    if (ad) {
      setCurrentAd(ad);
      setForm({
        name: ad.name,
        unitId: ad.unitId,
        active: ad.active,
      });
    } else {
      setCurrentAd(null);
      setForm({ name: "", unitId: "", active: true });
    }
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  // 🔹 Save Ad
  const saveAd = async () => {
    setError(null);

    if (!form.unitId.trim()) {
      setError("Ad Unit ID cannot be empty.");
      return;
    }

    const payload = {
      name: form.name,
      googleAdsUnitId: form.unitId,
      isAdEnable: form.active,
      ...(currentAd && { _id: currentAd.id }),
    };

    try {
      const res = await axios.post(`${API_URL}/add-or-update`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          "Content-Type": "application/json",
        },
      });

      if (res.data?.config?._id) {
        // ⭐ Name save here
        localStorage.setItem("adName", form.name);

        fetchAds();
        closeModal();
      } else {
        setError(res.data.message || "Failed to save ad configuration.");
      }
    } catch (err) {
      setError("API error: Could not save/update ad.");
    }
  };

  // 🔹 Delete Modal
  const openDelete = (ad) => {
    setCurrentAd(ad);
    setIsDeleteOpen(true);
  };

  const closeDelete = () => setIsDeleteOpen(false);

  // 🔹 Confirm Delete
  const confirmDelete = async () => {
    setError(null);

    try {
      const res = await axios.delete(`${API_URL}/remove`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });

      if (res.status === 200) {
        localStorage.removeItem("adName"); // ⭐ FIXED
        fetchAds();
        closeDelete();
      } else {
        setError("Failed to delete ad configuration.");
      }
    } catch (err) { }
  };

  // 🔹 Toggle Active
  const toggleActive = async (ad) => {
    const newActiveStatus = !ad.active;

    setAds((prev) =>
      prev.map((a) =>
        a.id === ad.id ? { ...a, active: newActiveStatus } : a
      )
    );

    const payload = {
      _id: ad.id,
      googleAdsUnitId: ad.unitId,
      isAdEnable: newActiveStatus,
    };

    try {
      await axios.post(`${API_URL}/add-or-update`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });

      fetchAds();
    } catch (err) { }
  };

  return (
    <Outlet>
      <div className="ads-page">
        <header className="ads-header">
          <h1>Ads Management</h1>
          <button className="btn-add" onClick={() => openModal()}>
            <PlusCircle className="icon" /> Add Ads
          </button>
        </header>

        {error && <div className="alert-error">{error}</div>}

        <div className="ads-table">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Unit ID</th>
                  <th>Status</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ads.length > 0 ? (
                  ads.map((ad) => (
                    <tr key={ad.id}>
                      <td className="Adname">{ad.name}</td>
                      <td>{ad.unitId}</td>
                      <td>
                        <span className={`status ${ad.active ? "live" : "inactive"}`}>
                          {ad.active ? <CheckCircle className="status-icon" /> : <XCircle className="status-icon" />}
                          {ad.active ? "LIVE" : "INACTIVE"}
                        </span>
                      </td>
                      <td>
                        <div
                          className={`toggle ${ad.active ? "on" : "off"}`}
                          onClick={() => toggleActive(ad)}
                        ></div>
                      </td>
                      <td className="actions">
                        <button className="btn-edit" onClick={() => openModal(ad)}>
                          <Edit className="icon" />
                        </button>
                        <button className="btn-delete" onClick={() => openDelete(ad)}>
                          <Trash2 className="icon" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No ads found</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Add/Edit Modal */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <h2>{currentAd ? "Edit Ad Unit" : "Add Ad Unit"}</h2>

              <input
                type="text"
                placeholder="Ad Name (e.g., Homepage Banner)"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />

              <input
                type="text"
                placeholder="Ad Unit ID (e.g., ad-12345)"
                value={form.unitId}
                onChange={(e) => setForm({ ...form, unitId: e.target.value })}
              />

              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={(e) =>
                    setForm({ ...form, active: e.target.checked })}
                />
                Set as Active
              </label>

              <div className="modal-actions">
                <button onClick={closeModal} className="clos">
                  Cancel
                </button>
                <button className="btn-primarya" onClick={saveAd}>
                  {currentAd ? "Update Ad" : "Add Ad"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Modal */}
        {isDeleteOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <h2 style={{ color: "red" }}>Confirm Deletion</h2>
              <p>
                Are you sure you want to delete Ad Unit ID: <b>{currentAd?.unitId}</b>?
              </p>
              <div className="modal-actions">
                <button onClick={closeDelete} className="clos">
                  Cancel
                </button>
                <button className="btn-danger" onClick={confirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Outlet>
  );
};

export default AdsManagement;
